/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon16Regular = forwardRef('ArrowFigureACircleRightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.25 8A.75.75 0 0 1 5 7.25h4.428L8.02 6.076a.75.75 0 1 1 .96-1.152l2.078 1.732c.84.7.84 1.989 0 2.688L8.98 11.076a.75.75 0 0 1-.96-1.152L9.428 8.75H5A.75.75 0 0 1 4.25 8Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z" })));
});
